import gp from 'generate-password';


export const generatePass= () => {
    return gp.generate({ length: 10, numbers: true,  excludeSimilarCharacters: true, exclude: '", <, >, ' });
}

